/* ===========================================================================
 * 08 Left - Frame Upsell  (Selly replacement)
 * ---------------------------------------------------------------------------
 * When a PAPER print is added to cart, pops a modal offering the matching-size
 * frame (Black / White / Natural Wood, with photos) at full price, one click
 * to add. Pure theme JS - reads Shopify's own product data, no backend.
 *
 * Skips: metal prints, sizes with no matching frame (e.g. 4x6), the frames
 * product itself, and prints whose matching frame is already in the cart.
 *
 * Load once globally (e.g. a Custom Liquid block in the theme footer):
 *   <script src="{{ 'frame-upsell.js' | asset_url }}" defer></script>
 *
 * Pure ASCII on purpose (special chars via HTML entities / \u) so a paste into
 * Shopify can never corrupt it.
 * ======================================================================== */
(function () {
  "use strict";
  if (window.__frameUpsellLoaded) return;
  window.__frameUpsellLoaded = true;

  var VERSION = "2026-10-28.1";
  console.log("%c[08L frame-upsell] " + VERSION, "color:#0a0a0a;background:#f9cb0c;padding:2px 6px;border-radius:3px;font-weight:700");

  var FRAMES_HANDLE = "frames";
  /* POPUP OFF (Ryan 2026-10-28). Frames are now chosen ON the product page
     (snippet frame-pick-08l.liquid: a Frame row under Size, the main photo shows
     the print framed, Add to Cart adds both). The popup was a full-screen stop
     at the moment of adding, and making it bigger in August sold no more frames
     (about 1 in 10 paper-print orders either way). With this false, claims() is
     always false (08l-product.liquid opens the cart drawer itself) and no add
     ever shows the popup. The composite helpers below are shared with the
     product page through window.OLFrameUpsell. Set true to bring the popup back. */
  var POPUP_ON = false;
  /* ADD-ON SKUs THAT MUST NEVER TRIGGER A FRAME OFFER.
     These are not prints. They are the products the customize / materials flow
     adds alongside a print, and one of them slipped through: the wood + canvas
     SKU is "airport-layouts-bonus-designs-and-media", whose variant reads
     "Wood / 12 x 18 / Maple (Wood Only)". itemSpecs() only treated metal and
     canvas as non-paper, so CANVAS was excluded but WOOD was not - a 12 x 18
     wood print matched a frame size and the popup offered to frame it.
     Ryan 2026-08-12: "the frame pop needs to be killed on any canvas or wood
     option too." Blocking by handle is sturdier than by option text, because it
     does not depend on how a variant happens to be worded. */
  var NO_UPSELL_HANDLES = [
    "airport-layouts-bonus-designs-and-media",  // Wood / Canvas
    /* Resolved from the variant ids in customize.js against the live catalogue,
       not guessed - two obvious guesses were wrong: the colour SKU is
       "color-change-1", not "color-change", and the orientation one is
       "layout-change", not "diagram-orientation". A wrong handle here fails
       silently, which is the worst kind of guard. */
    "color-change-1",   // Color Change
    "text-change",      // Text/Design Change
    "layout-change",    // Layout Change
    "version-change"    // Version Change
  ];
  var INK = "#0a0a0a", YELLOW = "#f9cb0c", RED = "#c42126";
  var FONT = '"proxima-nova","Proxima Nova",-apple-system,BlinkMacSystemFont,"Helvetica Neue",Helvetica,Arial,sans-serif';

  var state = { suppress: false, open: false, frameMap: null, cssDone: false };

  // ---- helpers -----------------------------------------------------------
  function money(cents) {
    var s = (cents / 100).toFixed(2);
    return "$" + s.replace(/\.00$/, "");
  }
  // Orientation-agnostic: "30 x 20" and "20 x 30" are the same size (a 30x20
  // blend fits a 20x30 frame), so we sort the two dimensions before comparing.
  function normSize(s) {
    s = (s || "").toLowerCase().replace(/\s+/g, "").replace(/[\u00d7x]/g, "x");
    var m = s.match(/^(\d+)x(\d+)$/);
    if (m) { var a = +m[1], b = +m[2]; return Math.min(a, b) + "x" + Math.max(a, b); }
    return s;
  }
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  // ---- frames product -> { size: [ {color, variantId, price, image} ] } --
  function loadFrames() {
    if (state.frameMap) return Promise.resolve(state.frameMap);
    var mock = window.__FRAME_UPSELL_FRAMES__;
    var p = mock ? Promise.resolve(mock) : fetch("/products/" + FRAMES_HANDLE + ".js").then(function (r) { return r.json(); });
    return p.then(function (data) {
      var map = {};
      (data.variants || []).forEach(function (v) {
        var opts = v.options || [];
        var size = (opts[0] || "").trim(), color = (opts[1] || "").trim();
        if (!size || !v.available) return;
        (map[size] = map[size] || []).push({
          color: color, variantId: v.id, price: v.price,
          image: (v.featured_image && v.featured_image.src) || (data.images && data.images[0]) || ""
        });
      });
      state.frameMap = map;
      return map;
    });
  }

  // ---- FRAME MOCKS -------------------------------------------------------
  // Straight-on PNGs with a FULLY TRANSPARENT window, one per colour. The
  // customer's print is layered behind the PNG so the swatch shows their own
  // art in the frame. All artwork is 2:3, so one mock per colour is enough.
  //
  // WINDOW is the transparent opening measured as a percentage of the PNG,
  // from each edge. Set these from the actual files - they are read off the
  // alpha channel, not guessed. Every colour must share the same numbers or
  // the art visibly jumps when you switch colour.
  //
  // Leave FRAME_MOCKS empty to fall back to the old behaviour (the frame
  // product's own photo), so this cannot break if the files are not up yet.
  // All three measured off the alpha channel and PIXEL-IDENTICAL: 1200x1200,
  // window inset top 16.58 / right 27.17 / bottom 16.08 / left 27.08 on every
  // one, delta 0.00%. So the art does not shift when the colour changes.
  // Keys must match the Frame Color variant values (matched case-insensitively).
  var FRAME_MOCKS = {
    "Black":        "https://cdn.shopify.com/s/files/1/0789/2895/files/BlackFrame.png?v=1785717725",
    "White":        "https://cdn.shopify.com/s/files/1/0789/2895/files/WhiteFrame.png?v=1785718207",
    "Natural Wood": "https://cdn.shopify.com/s/files/1/0789/2895/files/WoodFrame.png?v=1785718207"
  };
  // MEASURED off BlackFrame.png (1200x1200) by reading the alpha channel.
  // The frame has a SOFT BEVEL: bounds taken at alpha>40 sit at the START of
  // that ramp, which left a ~2% strip (worst on the right: 29.08 vs 27.17) with
  // no art behind it - it read as a pale seam between print and moulding. Taken
  // at alpha>=128 the bounds are identical to alpha>=230, i.e. fully opaque, so
  // those are the real inner edge. These numbers are that edge MINUS 0.5% bleed,
  // so the art tucks under the bevel and no seam can show. The moulding is
  // opaque there, so the bleed is invisible.
  // The mock is SQUARE (1200x1200), so the swatch box must be 1/1 or these
  // percentages will not line up.
  var FRAME_WINDOW = { top: 16.08, right: 26.67, bottom: 15.58, left: 26.58 };

  // GLASS. Cannot be baked into the frame PNG - that window has to stay clear
  // for the artwork to show through - so the sheen is its own layer over the
  // art. Set GLASS.on = false to kill it, or drop the opacity to taste.
  // GLASS.png: optional. A transparent PNG of just the reflection, if a real
  // photographed glare is wanted instead of the gradient.
  var GLASS = { on: true, opacity: 0.14, angle: 118, png: "" };
  /* ---- HORIZONTAL PRINTS (2026-10-26) ----------------------------------
     The Windows posters are 3:2 LANDSCAPE, stored as a transparent 2048
     square with the poster inset (204,477 to 1844,1570). Dropping that into
     the upright frame cropped it to a strip. So the art is measured first:
     its opaque box (where the poster actually is) and its real orientation.
     A landscape print gets the same frame PNG turned 90 degrees, with the
     window turned with it, and the art is scaled so its box fills the
     window. An opaque image (every airport diagram) measures as the full
     image and is drawn exactly as before. snippets/cart-products.liquid
     reads the same numbers from the frame line (_art_box, _frame_orient). */
  // FRAME_WINDOW turned 90 degrees clockwise with the PNG.
  var FRAME_WINDOW_LANDSCAPE = { top: FRAME_WINDOW.left, right: FRAME_WINDOW.top, bottom: FRAME_WINDOW.right, left: FRAME_WINDOW.bottom };
  var FULL_ART = { x: 0, y: 0, w: 1, h: 1, landscape: false };
  function measureArt(url) {
    return new Promise(function (resolve) {
      var settled = false;
      function done(v) { if (!settled) { settled = true; resolve(v); } }
      if (!url) return done(FULL_ART);
      var img = new Image();
      img.crossOrigin = "anonymous";   // cdn.shopify.com sends Access-Control-Allow-Origin: *
      img.onload = function () {
        var nw = img.naturalWidth || 1, nh = img.naturalHeight || 1;
        var whole = { x: 0, y: 0, w: 1, h: 1, landscape: nw > nh * 1.05 };
        try {
          var S = 200, c = document.createElement("canvas");
          c.width = S; c.height = S;
          var g = c.getContext("2d");
          g.drawImage(img, 0, 0, S, S);
          var d = g.getImageData(0, 0, S, S).data, x0 = S, y0 = S, x1 = -1, y1 = -1;
          for (var y = 0; y < S; y++) for (var x = 0; x < S; x++) {
            if (d[(y * S + x) * 4 + 3] > 16) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
          }
          if (x1 < 0) return done(whole);
          var bw = (x1 - x0 + 1) / S, bh = (y1 - y0 + 1) / S;
          done({ x: x0 / S, y: y0 / S, w: bw, h: bh, landscape: (bw * nw) / (bh * nh) > 1.05 });
        } catch (e) { done(whole); }   // tainted canvas etc.: orientation from the file's own shape
      };
      img.onerror = function () { done(FULL_ART); };
      img.src = url;
      setTimeout(function () { done(FULL_ART); }, 3000);
    });
  }
  function windowFor(fit) { return fit && fit.landscape ? FRAME_WINDOW_LANDSCAPE : FRAME_WINDOW; }
  // background-size/position that make the art's box exactly fill the window.
  function artFitCSS(fit) {
    if (!fit || (fit.w >= 0.995 && fit.h >= 0.995)) return "background-size:cover;background-position:center;";
    var px = fit.w < 0.995 ? (fit.x / (1 - fit.w)) * 100 : 50;
    var py = fit.h < 0.995 ? (fit.y / (1 - fit.h)) * 100 : 50;
    return "background-size:" + (100 / fit.w).toFixed(3) + "% " + (100 / fit.h).toFixed(3) + "%;background-position:" + px.toFixed(3) + "% " + py.toFixed(3) + "%;";
  }
  function boxStyle(W) { return "top:" + W.top + "%;right:" + W.right + "%;bottom:" + W.bottom + "%;left:" + W.left + "%;"; }

  function mockFor(color) {
    var k = Object.keys(FRAME_MOCKS).find(function (n) {
      return n.toLowerCase() === String(color || "").toLowerCase();
    });
    return k ? FRAME_MOCKS[k] : "";
  }

  // ---- read size + material from an added line item ----------------------
  function itemSpecs(item) {
    var size = "", material = "", allVals = "";
    var owv = item.options_with_values;
    if (Array.isArray(owv)) {
      owv.forEach(function (o) {
        var n = (o.name || "").toLowerCase();
        allVals += " " + (o.value || "");
        if (n === "size") size = o.value;
        // Regular prints call it "Material"; blends call it "Product"
        // (Fine Art / Metal / Canvas). Accept either.
        if (n === "material" || n === "product") material = o.value;
      });
    }
    if ((!size || !material) && item.variant_title) {
      var parts = item.variant_title.split("/").map(function (s) { return s.trim(); });
      allVals += " " + item.variant_title;
      if (!size) size = parts[parts.length - 1];
      if (!material && parts.length >= 2) material = parts[parts.length - 2];
    }
    // Frames are paper-only. Anything that mentions metal or canvas in ANY
    // option (regardless of which option holds it) is not a paper print.
    /* wood and acrylic added 2026-08-12 - a wood print is not framed either, and
       relying on the handle list alone would miss a future SKU. */
    var paper = !/metal|canvas|wood|acrylic/i.test(material + " " + allVals);
    // The line item carries the print's own image - that is what we composite
    // into the frame mock so the swatch shows THEIR art, not a stock frame shot.
    // _art_image wins (2026-10-26): a White Line print carries its White Line
    // preview there, while item.image is still the variant's Original photo.
    // Using item.image put the Original into the frame for a White Line order.
    var props = item.properties || {};
    var art = props._art_image || item.image || (item.featured_image && (item.featured_image.url || item.featured_image.src)) || "";
    return { size: size, material: material, paper: paper, art: art };
  }
  /* A human-readable name for the print a frame belongs to. This is what shows
     on the order, the packing slip and in Shopify admin, so it has to read
     cleanly to whoever is boxing it: title first, then the variant that
     identifies the exact piece. Line items expose these under different keys
     depending on where they came from, hence the fallbacks. */
  function printLabel(item) {
    var title = item.product_title || item.title || "";
    // item.title is sometimes "Product - Variant"; do not repeat the variant.
    var variant = item.variant_title || "";
    // The style is not in the variant (White Line is a property on the same
    // variant), so name it here or the framer cannot tell which art to frame.
    var style = item.properties && item.properties.Style;
    if (style) variant = variant ? (variant + ", " + style) : style;
    if (variant && title.indexOf(variant) !== -1) return title;
    return variant ? (title + " (" + variant + ")") : title;
  }

  function handleFromItem(item) {
    if (item.handle) return item.handle;
    var m = (item.url || "").match(/\/products\/([^?\/]+)/);
    return m ? m[1] : "";
  }

  /* ---- WHO OPENS THE CART DRAWER (2026-10-01) ---------------------------
     Horizon's "Auto-open cart drawer" was OFF, so nothing opened the cart
     after Add to Cart - a phone shopper got a tiny "Added to cart" line and
     had to find the bag icon. Turning it on creates a new problem: the drawer
     is a native modal <dialog>, which lives in the browser's TOP LAYER, above
     every z-index. Open it at the same moment as this popup and it covers the
     frame offer completely.

     So the order is fixed: frame offer FIRST, cart drawer AFTER.
       - claims(item) is the one synchronous answer to "will the frame popup
         want this add?". 08l-product.liquid asks it before dispatching its
         cart event, and dispatches action:"update" (refresh, no open) instead
         of "add" when the answer is yes.
       - This file then opens the drawer itself: when the popup closes by any
         route, or the moment it decides not to show after all (frame already
         in the cart, no frame for that size, a failed lookup).
     claims() is deliberately the SAME tests onCartAdd uses, so the two can
     never disagree about who is responsible for opening the drawer. */
  var FRAME_SIZES = ["12x18", "18x24", "20x30", "24x36"];  // until frames.js loads
  function claims(item) {
    if (!POPUP_ON || !item) return false;
    var h = handleFromItem(item);
    if (h === FRAMES_HANDLE || NO_UPSELL_HANDLES.indexOf(h) > -1) return false;
    var spec = itemSpecs(item);
    if (!spec.paper || !spec.size) return false;
    var sizes = state.frameMap ? Object.keys(state.frameMap) : FRAME_SIZES;
    return sizes.some(function (k) { return normSize(k) === normSize(spec.size); });
  }

  function cartDrawer() { return document.getElementById("cart-drawer"); }   // <theme-drawer>
  function closeCartDrawer() {
    var d = cartDrawer();
    try { if (d && d.isOpen && typeof d.close === "function") d.close(); } catch (e) {}
  }
  /* Open the drawer with FRESH contents. Dispatching the theme's own event with
     action "add" is the documented path: cart-drawer.js re-renders from the
     sections, then opens - and only if "Auto-open cart drawer" is on and the
     cart is not empty, so this stays harmless if the setting is ever turned
     back off. */
  function openCartDrawer() {
    var ids = cartSectionIds();
    var secs = ids.length
      ? fetch("/?sections=" + encodeURIComponent(ids.join(","))).then(function (r) { return r.ok ? r.json() : {}; }).catch(function () { return {}; })
      : Promise.resolve({});
    Promise.all([fetch("/cart.js").then(function (r) { return r.json(); }), secs]).then(function (out) {
      dispatchCart(out[0], out[1], "add");
    }).catch(function () {});
  }

  // ---- cart-add interception (fetch + XHR) -------------------------------
  function watchCart() {
    var of = window.fetch;
    if (of) {
      window.fetch = function () {
        var url = (typeof arguments[0] === "string") ? arguments[0] : (arguments[0] && arguments[0].url) || "";
        var p = of.apply(this, arguments);
        if (/\/cart\/add(\.js)?(\?|$)/.test(url) && !state.suppress) {
          p.then(function (res) {
            try { res.clone().json().then(onCartAdd).catch(function () {}); } catch (e) {}
          });
        }
        return p;
      };
    }
    // XHR fallback (older add paths)
    var open = XMLHttpRequest.prototype.open, send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__fuUrl = u; return open.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      if (/\/cart\/add(\.js)?(\?|$)/.test(xhr.__fuUrl || "") && !state.suppress) {
        xhr.addEventListener("load", function () {
          try { onCartAdd(JSON.parse(xhr.responseText)); } catch (e) {}
        });
      }
      return send.apply(this, arguments);
    };
  }

  function onCartAdd(data) {
    if (!POPUP_ON || state.suppress || state.open || !data) return;
    var items = data.items ? data.items : (data.id ? [data] : []);
    var found = null;
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var h = handleFromItem(item);
      if (h === FRAMES_HANDLE) continue;                        // never upsell a frame
      if (NO_UPSELL_HANDLES.indexOf(h) > -1) continue;          // add-ons are not prints
      var spec = itemSpecs(item);
      if (!spec.paper) continue;                                // paper only (skip metal/canvas)
      /* Remember WHICH print triggered this so the frame can be stamped with it.
         product_title is the print's name; variant_title carries the material /
         size / colorway. Fall back through the shapes a line item can take. */
      spec.forPrint = printLabel(item);
      found = spec; break;
    }
    if (!found) return;
    /* If the popup does NOT show, the cart drawer must open instead - but ONLY
       for an add that claims() said yes to, because only those were held back
       by 08l-product.liquid. Any other add (a stock-template product, a gift
       card, a 4x6) has already opened the drawer through the theme itself, and
       a second open request re-renders it mid-transition (Horizon logs
       "Transition was aborted"). Caught in the 10-01 regression sweep. */
    var claimedAdd = items.some(function (it) { try { return claims(it); } catch (e) { return false; } });
    var released = false;
    /* Never open the drawer over another 08L popup (blend builder, customize):
       it is top-layer and would bury that popup's confirmation. Wait for the
       shared lock, same rule showWhenFree follows. */
    function release() {
      if (released) return; released = true;
      if (!claimedAdd) return;
      if (!window.__OL_MODAL) { openCartDrawer(); return; }
      var tries = 0, iv = setInterval(function () {
        if (!window.__OL_MODAL || ++tries > 40) { clearInterval(iv); openCartDrawer(); }
      }, 300);
    }
    loadFrames().then(function (map) {
      var key = Object.keys(map).find(function (k) { return normSize(k) === normSize(found.size); });
      if (!key) { release(); return; }                           // 4x6 / no matching frame
      /* Don't nag - but count, do not just look.
         This used to suppress the popup whenever ANY frame of this size was in
         the cart, so a customer buying three 12x18 prints was offered exactly
         one 12x18 frame and never asked again. Most people framing one print
         want the others to match, so that was quietly costing frame sales.
         Compare quantities instead: offer only while matching-size PAPER prints
         outnumber matching-size frames. Three prints + one frame still asks;
         three prints + three frames stays quiet. Quantities are summed rather
         than lines counted, because two of the same print is one line item. */
      fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
        var ids = {};
        map[key].forEach(function (f) { ids[f.variantId] = 1; });
        var frames = 0, prints = 0;
        (cart.items || []).forEach(function (li) {
          var qty = li.quantity || 1;
          if (ids[li.variant_id || li.id]) { frames += qty; return; }
          if (handleFromItem(li) === FRAMES_HANDLE) return;   // a frame of another size
          var s = itemSpecs(li);
          if (!s.paper || !s.size) return;                    // metal/canvas do not take a frame
          if (normSize(s.size) === normSize(found.size)) prints += qty;
        });
        if (prints > frames) showWhenFree(key, map[key], found.art, found.forPrint, release);
        else release();                                          // already framed
      }).catch(function () { showWhenFree(key, map[key], found.art, found.forPrint, release); });
    }).catch(release);                                           // frames.js failed
  }

  // ---- styles ------------------------------------------------------------
  function injectCSS() {
    if (state.cssDone) return; state.cssDone = true;
    var css = ""
      /* THE OVERLAY MUST SCROLL. Stacking the swatches on mobile (below) makes
         the modal taller than a phone screen, and a centred flex child that
         overflows its container gets clipped at BOTH ends with no way to reach
         it - the close button and the CTA would simply be unreachable.
         overflow-y:auto plus margin:auto on the modal is the pairing that works:
         auto margins centre it while it fits and stop clipping once it does not.
         align-items:center alone does not survive the overflow. */
      + ".fu-overlay{position:fixed;inset:0;background:rgba(10,10,10,.55);display:flex;align-items:center;justify-content:center;overflow-y:auto;-webkit-overflow-scrolling:touch;z-index:999999;padding:18px;font-family:" + FONT + ";-webkit-font-smoothing:antialiased;opacity:0;transition:opacity .18s}"
      + ".fu-overlay.in{opacity:1}"
      + ".fu-modal{background:#fff;color:" + INK + ";width:100%;max-width:660px;margin:auto;border:1.5px solid " + INK + ";padding:26px 22px 0;position:relative;transform:translateY(8px);transition:transform .18s;box-sizing:border-box}"
      + ".fu-overlay.in .fu-modal{transform:none}"
      + ".fu-modal *{box-sizing:border-box}"
      + ".fu-close{position:absolute;top:10px;right:12px;background:none;border:0;font-size:26px;line-height:1;cursor:pointer;color:" + INK + ";opacity:.5}"
      + ".fu-close:hover{opacity:1}"
      + ".fu-eyebrow{font-size:11px;letter-spacing:.16em;text-transform:uppercase;font-weight:700;color:" + INK + ";opacity:.55;margin-bottom:6px}"
      + ".fu-h{font-size:25px;font-weight:800;letter-spacing:-.4px;margin:0 0 20px;line-height:1.12}"
      /* MOBILE STACKS THE FRAMES (Ryan 2026-08-21: "better if the frames were
         stacked vertically so you could see them better"). Three across in a
         375px modal gave each swatch ~82px, so the customer's own print inside
         the frame rendered about 38px - too small to judge a colour against,
         which is the entire job of this popup. Stacked, the image is ~250px.
         The cap keeps a large phone from blowing it up past what is useful.
         Desktop keeps the row: three side by side is easier to COMPARE, and
         there is room for it there. */
      + ".fu-swatches{display:flex;flex-direction:column;gap:12px;margin-bottom:20px}"
      + ".fu-sw-img{max-width:250px}"
      /* color is NOT optional here. `font:inherit` does not carry colour, and a
         <button> with none declared falls back to the UA default - which iOS
         paints blue, so the frame names read as links on a phone and as body
         text on desktop. Same bug as .olc-type in customize.js (Ryan 2026-08-21).
         Hover is scoped to (hover:hover): a touch device never fires hover-OFF,
         so the border stayed dark on whichever swatch was tapped first. */
      + ".fu-swatch{flex:0 0 auto;background:#fff;color:" + INK + ";border:1.5px solid rgba(10,10,10,.18);padding:10px 10px 12px;cursor:pointer;display:flex;flex-direction:column;align-items:center;gap:10px;font:inherit;transition:border-color .12s;-webkit-tap-highlight-color:transparent}"
      + "@media (hover:hover){.fu-swatch:hover{border-color:" + INK + "}}"
      + ".fu-swatch.sel{border:2px solid " + INK + ";box-shadow:inset 0 0 0 2px " + YELLOW + "}"
      + ".fu-sw-img{width:100%;aspect-ratio:1/1;background-size:cover;background-position:center;background-color:#f2f0ea;position:relative;overflow:hidden}"
      + ".fu-sw-img.has-mock{background-color:transparent;background-image:none!important}"
      + ".fu-sw-art{position:absolute;background-size:cover;background-position:center;background-color:#f2f0ea}"
      + ".fu-sw-frame{position:absolute;inset:0;background-size:contain;background-position:center;background-repeat:no-repeat}"
      + ".fu-sw-frame.is-landscape{transform:rotate(90deg)}"
      + ".fu-overlay.fu-measuring .fu-sw-img.has-mock{visibility:hidden}"
      + ".fu-sw-glass{position:absolute;pointer-events:none;background-repeat:no-repeat;background-size:cover;background-image:linear-gradient(" + GLASS.angle + "deg,rgba(255,255,255,.85) 0%,rgba(255,255,255,.35) 26%,rgba(255,255,255,0) 42%,rgba(255,255,255,0) 100%)}"
      + ".fu-sw-name{font-size:13px;letter-spacing:.05em;text-transform:uppercase;font-weight:600}"
      /* STICKY ON MOBILE. Stacked swatches push the modal past a phone screen,
         which would leave "Add frame" below the fold - the one thing you must
         never do to the primary action on a money path. Pinning the actions to
         the bottom of the scrollport keeps the CTA visible the whole way down.
         This is why .fu-modal has 0 bottom padding on mobile: the padding moved
         in here, so the white bar reaches the modal's bottom edge instead of
         floating above a 28px gap of scrolling artwork. */
      + ".fu-actions{display:flex;flex-direction:column;gap:9px;position:sticky;bottom:0;background:#fff;padding:12px 0 20px;border-top:1px solid rgba(10,10,10,.10)}"
      /* THESE THREE RULES WERE MALFORMED AND HALF OF THEM NEVER APPLIED.
         A find/replace had left an orphaned tail outside the closing brace:
             ".fu-add{ ...color .14s}" + INK + ";background:" + INK + ";...}"
         Everything after that first "}" is garbage at the top level, and a CSS
         parser recovers by swallowing tokens until the NEXT "{" - which belongs
         to the following rule. Verified in a real engine 2026-08-21: .fu-add:hover,
         .fu-add[disabled] and .fu-no:hover were all silently DROPPED, and the
         surviving .fu-add and .fu-no were byte-identical white outline buttons.
         So on the live popup the "Add frame" CTA and "No thanks" looked exactly
         the same, neither had a hover, and "Adding..." never dimmed - which also
         destroyed the outline-vs-filled distinction the .fu-no comment below
         depends on. Repaired to match .olc-add / .olc-radio in customize.js so
         both popups speak the same language: yellow primary on near-black type,
         same as the site's own Add to cart. */
      + ".fu-add{font:inherit;font-size:12px;letter-spacing:.11em;text-transform:uppercase;font-weight:700;padding:13px;border:0;border-radius:9px;background:" + YELLOW + ";color:#12120f;cursor:pointer;transition:background .14s,transform .14s;-webkit-tap-highlight-color:transparent}"
      + ".fu-add[disabled]{opacity:.45;cursor:default;transform:none;background:#d8d6cd;color:#5a5a54}"
      /* DECLINE MUST NOT BE A DARK PATTERN (Ryan 2026-07-29: "I hate when
         companies do that"). It used to be 12.5px, unfilled, borderless,
         underlined AND opacity .6 - four separate signals all making it
         weaker than the accept. Now it matches .fu-add on font-size, weight,
         letter-spacing, padding and hit area, at FULL opacity. It stays
         visually secondary through outline-vs-filled only, which is honest.
         Do not shrink it or fade it again. */
      + ".fu-no{font:inherit;font-size:12px;letter-spacing:.11em;text-transform:uppercase;font-weight:700;padding:13px;border-radius:9px;border:1.5px solid " + INK + ";background:none;color:" + INK + ";cursor:pointer;transition:background .14s,color .14s;-webkit-tap-highlight-color:transparent}"
      /* Hovers scoped to a real pointer. A touch device never fires hover-OFF,
         so on a phone the first tap left the decline stuck black-on-white. */
      + "@media (hover:hover){"
      + "  .fu-add:hover{background:#e0b400;transform:translateY(-1px)}"
      + "  .fu-no:hover{background:" + INK + ";color:#fff}"
      + "}"
      /* The add-frame failure had NO message element at all - the button just
         reset to "Try again" and Shopify's reason was thrown on the floor.
         That is the exact shape of the bug that hid the dead White Line variant
         for a month. RED, because a silent failure on a money path is the one
         thing this popup must never do again. */
      + ".fu-msg{margin:10px 0 0;font-size:13px;line-height:1.4;color:" + RED + ";text-align:center;min-height:0}"
      + ".fu-done{text-align:center;padding:14px 0 4px}"
      + ".fu-done .fu-check{display:inline-flex;align-items:center;justify-content:center;width:46px;height:46px;border-radius:50%;background:" + YELLOW + ";margin-bottom:12px;font-size:24px;font-weight:800}"
      + ".fu-done h4{margin:0 0 4px;font-size:17px;font-weight:800}"
      + ".fu-done p{margin:0;font-size:13px;opacity:.7}"
      /* DESKTOP PUTS IT ALL BACK: three across, full-size buttons, no sticky bar.
         Ryan 2026-08-02: "make the whole thing a bit bigger, at least for
         desktop - hard to see".

         THIS BLOCK MUST STAY LAST IN THE SHEET. A media query adds NO
         specificity, so .fu-actions{position:static} in here and the mobile
         .fu-actions{position:sticky} below it are a straight tie, and source
         order decides. When this block sat further up (where the old one did),
         every desktop reset lost to the mobile rule that followed it and the
         desktop popup silently wore the phone layout - sticky bar, small
         buttons, stacked swatches. Caught 2026-08-21 before it shipped, by
         rendering it rather than reading it. Add new mobile rules ABOVE, and
         give each one its counterpart here. */
      + "@media (min-width:760px){"
      + "  .fu-modal{max-width:900px;padding:40px 40px 34px}"
      + "  .fu-h{font-size:29px;margin:0 0 24px}"
      + "  .fu-swatches{flex-direction:row;gap:20px;margin-bottom:28px}"
      + "  .fu-swatch{flex:1;padding:14px 14px 16px;gap:12px}"
      + "  .fu-sw-img{max-width:none}"
      + "  .fu-sw-name{font-size:14px}"
      + "  .fu-actions{position:static;gap:11px;padding:0;border-top:0}"
      + "  .fu-add,.fu-no{font-size:13px;padding:17px}"
      + "}";
    var tag = document.createElement("style");
    tag.id = "fu-style";
    tag.textContent = css;
    document.head.appendChild(tag);
  }

  // ---- popup -------------------------------------------------------------
  // Defer the frame offer until any other 08L modal (e.g. the blend builder)
  // has closed, so two popups never stack. Shared lock: window.__OL_MODAL.
  function showWhenFree(size, frames, art, forPrint, onDone) {
    onDone = onDone || function () {};
    if (!window.__OL_MODAL) { showPopup(size, frames, art, forPrint, onDone); return; }
    var tries = 0;
    var iv = setInterval(function () {
      if (!window.__OL_MODAL) { clearInterval(iv); if (!state.open) showPopup(size, frames, art, forPrint, onDone); else onDone(); }
      else if (++tries > 40) { clearInterval(iv); onDone(); }
    }, 300);
  }

  function showPopup(size, frames, art, forPrint, onDone) {
    if (state.open) { if (onDone) onDone(); return; }
    state.open = true; window.__OL_MODAL = true;
    /* Another add path (customize, blend) may already have opened the drawer.
       It sits in the top layer and would hide this popup, so step it aside;
       close() below brings it back. */
    closeCartDrawer();
    injectCSS();
    var selected = 0;
    var price = frames[0] ? frames[0].price : 0;

    var swHTML = frames.map(function (f, i) {
      var mock = mockFor(f.color);
      var inner;
      if (mock && art) {
        // their print behind, the transparent-window frame on top
        var W = FRAME_WINDOW;
        inner = '<span class="fu-sw-img has-mock">'
          + '<span class="fu-sw-art" style="top:' + W.top + '%;right:' + W.right + '%;bottom:' + W.bottom + '%;left:' + W.left + '%;'
          + 'background-image:url(\'' + esc(art) + '\')"></span>'
          + (GLASS.on
              ? '<span class="fu-sw-glass" style="top:' + W.top + '%;right:' + W.right + '%;bottom:' + W.bottom + '%;left:' + W.left + '%;'
                + 'opacity:' + GLASS.opacity + (GLASS.png ? ";background-image:url('" + esc(GLASS.png) + "')" : "") + '"></span>'
              : '')
          + '<span class="fu-sw-frame" style="background-image:url(\'' + esc(mock) + '\')"></span>'
          + '</span>';
      } else {
        inner = '<span class="fu-sw-img" style="background-image:url(\'' + esc(f.image) + '\')"></span>';
      }
      return '<button type="button" class="fu-swatch' + (i === 0 ? " sel" : "") + '" data-i="' + i + '">'
        + inner + '<span class="fu-sw-name">' + esc(f.color) + '</span></button>';
    }).join("");

    var ov = document.createElement("div");
    ov.className = "fu-overlay" + (art ? " fu-measuring" : "");
    var fit = null;   // filled by measureArt; travels to the cart on the frame line
    ov.innerHTML = ''
      + '<div class="fu-modal" role="dialog" aria-modal="true" aria-label="Add a matching frame">'
      + '  <button type="button" class="fu-close" aria-label="Close">&times;</button>'
      + '  <div class="fu-eyebrow">Complete your print</div>'
      + '  <h3 class="fu-h">Add a matching ' + esc(size) + ' frame?</h3>'
      + '  <div class="fu-swatches">' + swHTML + '</div>'
      + '  <div class="fu-actions">'
      + '    <button type="button" class="fu-add">Add frame &mdash; <span class="fu-price">' + money(price) + '</span></button>'
      + '    <button type="button" class="fu-no">No thanks</button>'
      + '    <p class="fu-msg" role="status" aria-live="polite"></p>'
      + '  </div>'
      + '</div>';
    document.body.appendChild(ov);
    requestAnimationFrame(function () { ov.classList.add("in"); });
    if (art) measureArt(art).then(function (m) {
      fit = m;
      var W = windowFor(m);
      ov.querySelectorAll(".fu-sw-art").forEach(function (el) { el.setAttribute("style", el.getAttribute("style").replace(/top:[^;]*;right:[^;]*;bottom:[^;]*;left:[^;]*;/, boxStyle(W)).replace(/;?\s*$/, ";") + artFitCSS(m)); });
      ov.querySelectorAll(".fu-sw-glass").forEach(function (el) { el.setAttribute("style", el.getAttribute("style").replace(/top:[^;]*;right:[^;]*;bottom:[^;]*;left:[^;]*;/, boxStyle(W))); });
      ov.querySelectorAll(".fu-sw-frame").forEach(function (el) { el.classList.toggle("is-landscape", !!m.landscape); });
      ov.classList.remove("fu-measuring");
    });

    var closed = false;
    function close() {
      if (closed) return; closed = true;
      ov.classList.remove("in");
      setTimeout(function () {
        ov.remove(); state.open = false; window.__OL_MODAL = false; document.removeEventListener("keydown", onKey);
        if (onDone) onDone(); else openCartDrawer();             // now the cart, with Checkout
      }, 180);
    }
    function onKey(e) { if (e.key === "Escape") close(); }
    document.addEventListener("keydown", onKey);

    ov.addEventListener("click", function (e) { if (e.target === ov) close(); });
    ov.querySelector(".fu-close").addEventListener("click", close);
    ov.querySelector(".fu-no").addEventListener("click", close);

    ov.querySelectorAll(".fu-swatch").forEach(function (btn) {
      btn.addEventListener("click", function () {
        selected = Number(btn.dataset.i);
        ov.querySelectorAll(".fu-swatch").forEach(function (b) { b.classList.toggle("sel", b === btn); });
      });
    });

    ov.querySelector(".fu-add").addEventListener("click", function () {
      var f = frames[selected];
      var btn = ov.querySelector(".fu-add");
      var msg = ov.querySelector(".fu-msg");
      btn.disabled = true; btn.textContent = "Adding..."; if (msg) msg.textContent = "";
      addFrame(f.variantId, cartSectionIds(), forPrint, art, fit).then(function (addRes) {
        refreshCart(addRes, "update");   // repaint only; close() opens the drawer
        ov.querySelector(".fu-modal").innerHTML =
          '<div class="fu-done"><div class="fu-check">&#10003;</div>'
          + '<h4>Frame added</h4><p>Your ' + esc(size) + " " + esc(f.color) + " frame is in the cart.</p></div>";
        setTimeout(close, 1500);
      }).catch(function (err) {
        btn.disabled = false; btn.textContent = "Try again";
        if (msg) msg.textContent = (err && err.shopifyMsg) || "Could not add that frame - please try again.";
      });
    });
  }

  // Cart-related section IDs in the DOM. Horizon re-renders ("morphs") these
  // from the cart:update event, so we request their fresh HTML on add.
  function cartSectionIds() {
    var ids = {};
    document.querySelectorAll("cart-items-component, cart-drawer-component, cart-icon").forEach(function (el) {
      var sid = el.getAttribute("data-section-id");
      if (!sid) { var host = el.closest("[data-section-id]"); sid = host && host.getAttribute("data-section-id"); }
      if (sid) ids[sid] = 1;
    });
    return Object.keys(ids);
  }

  function addFrame(variantId, sectionIds, forPrint, art, fit) {
    state.suppress = true;
    /* LINE ITEM PROPERTY: ties this frame to the print it was bought for.
       The cart has no native link between a frame line and a print line - the
       frames product is one product with Size + Colour variants - so without
       this the order shows "FRAMES - 12 x 18 / Black" with nothing saying which
       print it belongs to, and pairing is done by hand. Properties ride through
       to the order, packing slip and admin. A leading underscore would HIDE the
       property, which is the opposite of what is wanted here. */
    var item = { id: variantId, quantity: 1 };
    if (forPrint) item.properties = { "For print": forPrint };
    /* _art_image (2026-10-26): the print this frame holds (White Line preview
       when that was chosen). snippets/cart-products.liquid draws it inside the
       frame colour, so the cart shows THEIR print framed instead of the stock
       "FRAME YOUR PRINT" photo. Hidden from the customer by the underscore. */
    if (art) {
      item.properties = item.properties || {};
      item.properties._art_image = String(art).indexOf("//") === 0 ? "https:" + art : String(art);
      /* Where the print sits in that image, and which way the frame hangs, so
         the cart draws exactly what the offer showed (see measureArt). */
      if (fit && (fit.w < 0.995 || fit.h < 0.995)) item.properties._art_box = [fit.x, fit.y, fit.w, fit.h].map(function (n) { return n.toFixed(4); }).join(",");
      if (fit && fit.landscape) item.properties._frame_orient = "landscape";
    }
    var body = { items: [item] };
    if (sectionIds && sectionIds.length) { body.sections = sectionIds.join(","); body.sections_url = location.pathname; }
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (r.ok) return r.json();
      /* See blend.js / customize.js: never discard the server's reason. */
      return r.json().catch(function () { return null; }).then(function (body) {
        var err = new Error("add failed " + r.status);
        err.shopifyMsg = body && (body.description || body.message ||
          (typeof body.errors === "string" ? body.errors : ""));
        throw err;
      });
    }).finally(function () { state.suppress = false; });
  }

  // Tell the theme its cart changed. This store (Horizon) listens for
  // "cart:update" (ThemeEvents.cartUpdate) and morphs the cart sections from
  // event.detail.data.sections, updating the count from data.itemCount. We also
  // fire a few generic names as a harmless fallback for other themes.
  /* One place that speaks the theme's cart event. action "add" lets the drawer
     auto-open; "update" repaints the count and contents without opening it. */
  function dispatchCart(cart, sections, action) {
    try {
      var ev = new Event("shopify:cart:lines-update", { bubbles: true });
      ev.action = action;
      ev.promise = Promise.resolve({
        cart: { totalQuantity: cart.item_count },
        detail: { itemCount: cart.item_count, source: "frame-upsell", sections: sections || {} }
      });
      document.dispatchEvent(ev);
    } catch (e) {}
  }

  function refreshCart(addRes, action) {
    fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
      var sections = (addRes && addRes.sections) || {};
      /* HORIZON 4.1.3 - THE ONE THAT ACTUALLY WORKS.
         This file was written against theme #67, where "cart:update" was the
         event the drawer and the cart bubble listened for. 4.1.3 renamed it:
         it now listens for "shopify:cart:lines-update" and reads event.promise
         -> {cart:{totalQuantity}, detail:{itemCount, sections}}, with
         event.action === "add" telling the drawer to open itself.

         Measured on the live 4.1.3 store with one item in the cart server-side:
           dispatch "cart:update"               -> bubble stayed "Cart 0"
           dispatch "shopify:cart:lines-update" -> bubble became "Cart 1"

         That single missing event is the whole "the frame did not get added"
         bug. The frame WAS added - /cart/add.js returned 200 and /cart.js
         listed it - but nothing on the page ever repainted, so the frame only
         appeared on the next add-to-cart, which fired the correct event.
         08l-product.liquid was updated for 4.1.3 when the product page was
         rebuilt; this file was not, which is why the print refreshed the UI
         and the frame did not.

         The legacy events below are kept: they cost nothing and keep this
         file working if it is ever pasted back onto the old theme. */
      dispatchCart(cart, sections, action || "add");
      try {
        document.dispatchEvent(new CustomEvent("cart:update", {
          bubbles: true,
          detail: { resource: {}, sourceId: "frame-upsell", data: { itemCount: cart.item_count, source: "frame-upsell", sections: sections } }
        }));
      } catch (e) {}
      ["cart:refresh", "cart:updated", "cart:change"].forEach(function (name) {
        try { document.documentElement.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { cart: cart } })); } catch (e) {}
      });
    }).catch(function () {});
  }

  /* ---- KLAVIYO WAITS WHILE THE CART IS OPEN (2026-10-01) ------------------
     Klaviyo's desktop 15% popup fires on a 30 second timer. Klaviyo already
     skips the /cart PAGE, but it cannot see the slide-out drawer, so in testing
     the popup landed right on top of an open cart and its Checkout button.
     Klaviyo announces every form it opens with a documented window event
     ("klaviyoForms", detail.type "open", detail.formId). If that happens while
     the drawer is open, keep the form invisible and unclickable, and reveal it
     the moment the drawer closes - Klaviyo still decides IF it shows, this only
     decides WHEN. Embedded forms ("embedOpen") and teasers are not touched. */
  function klaviyoWaitsForCart() {
    var held = {};
    function drawerIsOpen() { var d = cartDrawer(); return !!(d && d.isOpen); }
    function overlayFor(id) {
      var el = document.querySelector('[data-testid="klaviyo-form-' + id + '"]');
      if (!el) return null;
      var top = null, p = el;
      while (p && p !== document.body) { if (getComputedStyle(p).position === "fixed") top = p; p = p.parentElement; }
      return top || el;
    }
    function hold(id, tries) {
      var o = overlayFor(id);
      if (!o) { if ((tries || 0) < 20) setTimeout(function () { hold(id, (tries || 0) + 1); }, 50); return; }
      o.style.setProperty("visibility", "hidden", "important");
      o.style.setProperty("pointer-events", "none", "important");
      held[id] = o;
    }
    function releaseAll() {
      Object.keys(held).forEach(function (id) {
        held[id].style.removeProperty("visibility");
        held[id].style.removeProperty("pointer-events");
      });
      held = {};
    }
    window.addEventListener("klaviyoForms", function (e) {
      var d = (e && e.detail) || {};
      if (d.type === "open" && d.formId && drawerIsOpen()) hold(d.formId, 0);
      if (d.type === "close" && d.formId) delete held[d.formId];
    });
    /* Watch <theme-drawer>'s own [open] attribute - that is what isOpen reads,
       and it drops the moment close() starts. The inner <dialog> stays open
       until the slide-out animation ends, so watching it would hold the form
       longer than needed (and forever if an animation never completes). */
    function watch() {
      var d = cartDrawer();
      if (!d) return;
      new MutationObserver(function () { if (!d.isOpen) releaseAll(); })
        .observe(d, { attributes: true, attributeFilter: ["open"] });
    }
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", watch); else watch();
  }
  klaviyoWaitsForCart();

  /* Shared with the product page's Frame row (frame-pick-08l.liquid), so the
     framed photo there is drawn by exactly the same numbers as the cart and the
     old popup. The page listens for "ol:frame-api" if this loads after it. */
  window.OLFrameUpsell = {
    version: VERSION, claims: claims, popupOn: POPUP_ON,
    loadFrames: loadFrames, mockFor: mockFor, measureArt: measureArt,
    windowFor: windowFor, artFitCSS: artFitCSS, boxStyle: boxStyle,
    normSize: normSize, glass: GLASS, frameWindow: FRAME_WINDOW
  };
  try { document.dispatchEvent(new Event("ol:frame-api")); } catch (e) {}
  loadFrames().catch(function () {});   // warm: claims() then uses the live size list

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", watchCart);
  else watchCart();
})();
